interface ListQuery {
  data?: {
    pages: readonly ({ data?: { result?: readonly unknown[] } } | undefined)[];
  };
}

/** Full-list loading/error states apply only before the first nonempty page. */
export const hasLoadedListItems = (query: ListQuery) =>
  query.data?.pages.some((page) => (page?.data?.result?.length ?? 0) > 0) ??
  false;
